// removed by extract-text-webpack-plugin
module.exports = {"Landing":"Landing__Landing__2uj_1","LandingTitle":"Landing__LandingTitle__1gVmA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Landing/Landing.css
// module id = 107
// module chunks = 0